import { ShareBaseItem } from './sharebase-item';

export interface ShareBaseLibrary extends ShareBaseItem{
    LibraryName:string;
    CreatedByUserName:string;
    IsPrivate: boolean;
    IconId:number;
    IconName:string;
    Embedded:any,
    Links: {
        SelfUri: string;
        RootFoldersUri: string;
        ActivitiesUri: string;
        IconUri: string;
        DocumentLocksUri: string;
    };
}

export function isShareBaseLibrary(item:any):item is ShareBaseLibrary {
    return item && 
        !item.FolderId &&
        angular.isDefined(item.LibraryId) &&
        angular.isDefined(item.LibraryName);
}


// WEBPACK FOOTER //
// ./src/phoenix/domain/sharebase-library.ts